export const STORAGE_KEYS = {
  SELECTED_RETAILER_ID: 'selectedRetailerId',
};
